export enum ContactTypeCodeEnum {
  JOBSITE = 'J',
  JOBSITE_REQUEST = 'JSM',
  CUSTOMER = 'C',
}
